var React = require('react');

function Menu (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"currentColor","strokeWidth":"2","fill":"none","fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round"},React.createElement("path",{"d":"M1 1.5h22M1 8.5h22M1 15.5h22"})));
}

Menu.defaultProps = {"viewBox":"0 0 24 17"};

module.exports = Menu;

Menu.default = Menu;
